import { z } from 'zod';

export const iPadDeviceCodeSchema = z.object({
  /** 8-digit numeric code. Globally unique while active. */
  code: z.string(),
  restaurantId: z.string(),
  /** Owner-assigned label, e.g. "Front counter". Copied onto the `iPad` at link time. */
  name: z.string(),

  _creationTime: z.number().optional(),
  _id: z.string().optional(),
  updatedAt: z.number().optional(),
});
export type IPadDeviceCode = z.output<typeof iPadDeviceCodeSchema>;

export const iPadDeviceCodeStrictSchema = iPadDeviceCodeSchema.safeExtend({
  name: z.string().trim().min(1, 'Name is required').max(50, 'Name must be 50 characters or less'),
  updatedAt: z.number().default(() => Date.now()),
});

export const iPadDeviceCodeCvxSchema = iPadDeviceCodeSchema.safeExtend({
  _creationTime: z.number(),
  _id: z.string(),
  updatedAt: z.number(),
});
export type IPadDeviceCodeCvx = z.output<typeof iPadDeviceCodeCvxSchema>;
